import { render, staticRenderFns } from "./ComponentHeader.vue?vue&type=template&id=77c6adbb&"
import script from "./ComponentHeader.vue?vue&type=script&lang=js&"
export * from "./ComponentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports